export default "__VITE_ASSET__DCFHoSMd__"